import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { PensionArrangementType } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { PensionType } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { PensionBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/PensionBase";
import { SubAccountActionIndicators } from "../../../../../../../Wrap/Models/Models/Shared/SubAccountActionIndicators";
import { hasSinglePayments } from "../../../../../../Shared/IST/Components/Shared/Utils";

export const needSingleContribution = (config: SubAccountActionIndicators, model: PensionBase) => {
    if (
        config.PensionType != PensionType.None &&
        !hasSinglePayments(model) &&
        (model.PensionTransfers || []).every((e) => e?.PensionSource == PensionArrangementType.Crystallised)
    ) {
        return true;
    }
    return false;
};

export const needPostTransfer = (config: SubAccountActionIndicators, model: PensionBase) => {
    if (
        config.PensionType == PensionType.None &&
        config.IsIncomePaymentDetailsSelected == true &&
        (model.PensionTransfers || []).every((ele) => ele.PensionSource !== PensionArrangementType.Crystallised)
    ) {
        return true;
    }
    return false;
};

export const showIncome = (config: SubAccountActionIndicators, model: PensionBase) => {
    if (!config.IsIncomePaymentDetailsSelected) {return false;}
    if (config.PensionType == PensionType.None) {
        return true;
    }
    return !CommonHelper.isNullOrEmpty(model.DrawdownModel?.InstructionId);
};
